<template>
  <article class="info-section">
    <div v-if="herd">
      <div class="info-section-header">
        <InfoSectionHeading>{{ herd.name }}</InfoSectionHeading>
        <p class="info-section-subheading" v-if="herd.visibility">
          Visibility: {{ capitalize(herd.visibility) }}
        </p>
        <div class="button-holder">
          <button class="elr-button elr-button-primary">Make Herd Private</button>
          <router-link
            :to="`/herd/${herd.user}/edit`"
            class="elr-button elr-button-primary"
            >Edit Herd</router-link
          >
        </div>
        <p v-if="herd.notes" class="info-section-subheading">
          {{ herd.notes }}
        </p>
        <ListStats :herd="herd" />
      </div>
      <div class="filter">
        <p>
          Total: {{ herd.item_count }} {{ plural("item", herd.item_count) }}
        </p>
        <h2 class="info-section-subheading">Filter Items:</h2>
        <FilterList
          @updated="updateFilters"
          title="Condition"
          field="condition"
          :items="conditions"
          :filters="filters.condition"
        />
        <FilterList
          @updated="updateFilters"
          title="Status"
          field="status"
          :items="statuses"
          :filters="filters.status"
        />
        <ViewToggle
          :displayStyle="displayStyle"
          @toggled="toggleDisplayStyle"
        />
        <div class="button-holder sort-list">
          <SortToggle
            v-for="sort in sorts"
            :key="sort.field"
            :field="sort.field"
            :activeField="activeSort.field"
            :direction="sort.direction"
            :buttonLabel="sort.label"
            @sorted="toggleSort"
          />
        </div>
      </div>
    </div>
    <div v-if="herd">
      <ListItemGrid v-if="status && displayStyle === 'grid'" :status="status">
        <HerdItemCard
          :key="item.id"
          v-for="item in items"
          :user="user"
          :item="item"
          :url="url(item.id)"
          @removed="removeItem"
        />
      </ListItemGrid>
    </div>
    <div v-if="status && displayStyle === 'list'" class="item-list-holder">
      <ul class="item-list">
        <ItemListHeader>
          <span>Name:</span>
          <span>Status:</span>
          <span>Condition:</span>
          <span>Generation:</span>
          <span>Grouping:</span>
        </ItemListHeader>
        <ListItem
          v-for="item in items"
          @removed="removeItem"
          model="herd-item"
          :key="item.id"
          :item="item"
          :user="user"
          :url="url(item.id)"
        >
          <span
            ><router-link :to="`/herd-item/${item.id}`">{{
              item.name
            }}</router-link></span
          >
          <span>{{ item.status }}</span>
          <span>{{ item.condition }}</span>
          <span
            ><router-link :to="`/generation/${item.generation.id}`">{{
              item.generation.name
            }}</router-link></span
          >
          <span
            ><router-link :to="`/grouping/${item.grouping.id}`">{{
              item.grouping.name
            }}</router-link></span
          >
        </ListItem>
      </ul>
    </div>
  </article>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import {
  capitalize,
  currency,
  infiniteScroll,
  plural,
  showPrompt,
} from "../../utils/helpers";
import ListItemGrid from "../../components/ListItemGrid/ListItemGrid";
import ListItem from "../../components/ListItem/ListItem";
import HerdItemCard from "../../components/HerdItemCard/HerdItemCard";
import InfoSectionHeading from "../../components/InfoSectionHeading/InfoSectionHeading";
import ViewToggle from "../../components/ViewToggle/ViewToggle";
import SortToggle from "../../components/SortToggle/SortToggle";
import ItemListHeader from "../../components/ItemListHeader/ItemListHeader";
import FilterList from "../../components/FilterList/FilterList";
import ListStats from "../../components/ListStats/ListStats";

export default {
  name: "Herd",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      herd: {},
      errors: [],
      num: 30,
      showFilters: false,
    };
  },
  components: {
    ListItemGrid,
    HerdItemCard,
    InfoSectionHeading,
    FilterList,
    SortToggle,
    ViewToggle,
    ListItem,
    ItemListHeader,
    ListStats,
  },
  async mounted() {
    if (this.user?.username) {
      this.herd = await this.fetchHerd({id: this.user?.username});
    }

    infiniteScroll(() => {
      console.log('get more items');
      // if (this.nextUrl && this.status !== "loading") {
      //   this.updateItems();
      // }
    });
  },
  computed: {
    ...mapGetters("herd", ["getByUserId"]),
    ...mapGetters("herdItem", ["getFilters", "getByHerdId"]),
    ...mapState("currentUser", { user: "currentUser" }),
    ...mapState("herdItem", [
      "status",
      "nextUrl",
      "displayStyle",
      "sorts",
      "total",
      "conditions",
      "statuses",
    ]),
    activeSort() {
      return this.sorts.filter((o) => o.active)[0];
    },
    items() {
      return this.getByHerdId(this.id);
    },
    filters() {
      return this.getFilters();
    },
  },
  methods: {
    capitalize,
    currency,
    plural,
    ...mapActions("herd", ["FETCH"]),
    ...mapActions("herdItem", [
      "FETCH_MORE",
      "CLEAR_FILTERS",
      "UPDATE_FILTERS",
      "CHANGE_DISPLAY_STYLE",
      "SORT",
      "FETCH_ALL",
    ]),
    async fetchHerd({ id }) {
      Promise.all([
        this.FETCH({ id }),
        this.FETCH_ALL({ id, num: 30 })
      ]).then(values => {
        const [herd, items] = values;
        this.herd = herd;
        console.log('items', items);
      });
    },
    url(id) {
      return `/herd-item/${id}`;
    },
    updateItems() {
      this.FETCH_MORE(this.filters);
    },
    removeItem(id) {
      showPrompt();

      return id;
    },
    toggleFilters() {
      this.showFilters = !this.showFilters ? true : false;
    },
    clearFilters() {
      this.CLEAR_FILTERS();
    },
    updateFilters({ name, filters }) {
      this.UPDATE_FILTERS({ name, value: filters, id: this.id, num: this.num });
    },
    toggleDisplayStyle({ display }) {
      this.CHANGE_DISPLAY_STYLE({ display });
    },
    toggleSort({ direction, field }) {
      this.SORT({ direction, field });
    },
  },
  watch: {
    $route() {},
    async user() {
      this.herd = await this.fetchHerd({id: this.user?.username});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/config";

.filter,
.item-list,
.list-stats {
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;
}

.item-list {
  padding-left: 0;
}

.button-holder {
  text-align: left;
  padding-top: 0;

  .elr-button {
    margin-right: 10px;
    width: auto;
  }
}

.view-toggle {
  margin-top: 40px;
}

.herd-filter button {
  margin: 0 10px 10px 0;
  max-width: 150px;
}

.sort-list button {
  margin-right: 10px;
}
</style>
